"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
class AStar {
    constructor(closerModifier) {
        this.pool = new AStarNodePool(closerModifier);
    }
    getCost(start, path) {
        let cost = 0;
        let prev = null;
        for (const step of path) {
            if (prev)
                cost += prev.getCostTo(step);
            prev = step;
        }
        return utils_1.round(cost);
    }
    getPath(start, end, area) {
        if (start === end)
            return [end];
        /*
          const before = performance.now();
          const result = this.getPathInternal(start, end, area);
          const after = performance.now();
          AStar.log(after - before, result && result.length);
          return result;
        }
      
        private getPathInternal(start: T, end: T, area?: IArea): T[] {
        */
        const open = new Set();
        const closed = new Set();
        let current;
        open.add(this.pool.getNode(start));
        while (open.size) {
            current = this.getNext(open, closed);
            if (current.child === end)
                return this.retrace(start, current);
            // if (current.tile.isEmpty && !this.hasRampBelow(current))
            //  continue;
            for (const [child, relation] of current.child.getNeighbors(area)) {
                const neighbor = this.pool.getNode(child);
                const movement = (current.pathCost || 0) + relation.cost;
                if (child.isObstacle)
                    throw new Error('No obstacle tiles should make it to A* algorithm');
                if (closed.has(neighbor))
                    continue;
                if (movement < neighbor.pathCost || !open.has(neighbor)) {
                    neighbor.pathCost = movement;
                    neighbor.estimatedCost = child.estimateDistanceTo(end);
                    neighbor.parent = current;
                    if (!open.has(neighbor))
                        open.add(neighbor);
                }
                if (!open.has(neighbor))
                    neighbor.dispose();
            }
        }
        for (const node of closed)
            node.dispose();
    }
    /*
     * Helpers
     */
    getNext(open, closed) {
        let best = null;
        for (let item of open) {
            if (!best || (item.cost < best.cost || (item.cost === best.cost && item.cost < best.cost)))
                best = item;
        }
        open.delete(best);
        closed.add(best);
        return best;
    }
    retrace(start, end) {
        const path = [];
        let current = end;
        while (current.child !== start) {
            path.push(current.child);
            current = current.parent;
        }
        return path.reverse();
    }
    static log(time, steps) {
        this.logs.push(time);
        const total = this.logs.reduce((sum, current) => sum + current);
        const average = total / this.logs.length;
        // console.log(`[A*] ${this.round(time)}ms for ${steps} steps (avg ${this.round(average)}ms)`);
    }
    static round(value) {
        return Math.round(value * 100) / 100;
    }
}
/*
 * PERFORMANCE
 */
AStar.logs = [];
exports.default = AStar;
class AStarNode {
    constructor(_child, closerModifier) {
        this._child = _child;
        this.closerModifier = closerModifier;
        this._isDisposed = false;
    }
    get child() {
        this.checkDisposed();
        return this._child;
    }
    get cost() {
        this.checkDisposed();
        return this.pathCost + this.estimatedCost * this.closerModifier;
    }
    get isDisposed() {
        return this._isDisposed;
    }
    init() {
        this._isDisposed = false;
    }
    dispose() {
        this.pathCost = null;
        this.estimatedCost = null;
        this.parent = null;
        this._isDisposed = true;
    }
    checkDisposed() {
        if (this.isDisposed)
            throw new DisposedInstanceInvocationError(`Instance of ${this.constructor.name} is disposed!`);
    }
}
class AStarNodePool {
    constructor(closerModifier) {
        this.closerModifier = closerModifier;
        this.pool = new WeakMap();
        this.using = new Set();
    }
    get liveInstancesCount() {
        return this.using.size;
    }
    getNode(tile) {
        let instance;
        if (this.pool.has(tile))
            instance = this.pool.get(tile);
        else
            instance = new AStarNode(tile, this.closerModifier);
        this.pool.set(tile, instance);
        this.using.add(instance);
        instance.init();
        return instance;
    }
    dispose(node) {
        if (Array.isArray(node)) {
            node.forEach(entry => this.dispose(entry));
            return;
        }
        this.using.delete(node);
        node.dispose();
    }
}
class DisposedInstanceInvocationError extends Error {
}



//////////////////
// WEBPACK FOOTER
// ./src/pathfinding/a-star.ts
// module id = 5
// module chunks = 0